import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const AuthGreeting = ()=>{
    const $ = c(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("circle", {
            cx: "95",
            cy: "111.78",
            r: "93",
            fill: "#F7FAFF"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsxs("g", {
            clipPath: "url(#clip0_19767_266285)",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M149.185 93.9294V203.174C149.185 205.833 147.016 207.99 144.319 207.99H45.2872C42.6118 207.99 40.4209 205.833 40.4209 203.174V186.153L40.5052 176.774V73.0142C40.5052 70.3553 42.675 68.1989 45.3714 68.1989H123.295L149.185 93.9084V93.9294Z",
                    fill: "white"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M144.32 208.387H45.288C43.8766 208.387 42.5494 207.843 41.5593 206.859C40.5692 205.875 40.0215 204.556 40.0215 203.153V186.132L40.1057 176.753L40.0847 73.0142C40.0847 70.125 42.4441 67.7802 45.3723 67.7802H123.296C123.401 67.7802 123.507 67.822 123.591 67.9058L149.481 93.6154C149.565 93.6991 149.608 93.7828 149.608 93.9085V93.9294C149.608 93.9294 149.608 93.9294 149.608 93.9503V203.195C149.608 204.598 149.06 205.917 148.07 206.901C147.059 207.843 145.731 208.387 144.32 208.387ZM45.3723 68.6176C42.9286 68.6176 40.9273 70.5856 40.9273 73.0142V176.753L40.8431 186.132V203.153C40.8431 204.326 41.3065 205.435 42.1492 206.252C42.9918 207.089 44.1083 207.55 45.288 207.55H144.32C145.5 207.55 146.616 207.089 147.459 206.252C148.301 205.414 148.765 204.326 148.765 203.153V94.0759L123.127 68.6176H45.3723Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M149.185 94.3898H128.351C126.876 94.3898 125.486 93.8245 124.454 92.7777C123.4 91.7309 122.832 90.37 122.832 88.9045V68.1987C122.832 68.0312 122.937 67.8846 123.084 67.8218C123.232 67.759 123.421 67.8009 123.548 67.9056L149.48 93.6779C149.607 93.8036 149.628 93.9711 149.564 94.1385C149.501 94.2851 149.354 94.3898 149.185 94.3898ZM123.674 69.2036V88.9045C123.674 90.1397 124.159 91.3122 125.043 92.1915C125.928 93.0708 127.108 93.5523 128.351 93.5523H148.174L123.674 69.2036Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M73.4107 115.807L61.1291 115.724C58.8118 115.703 56.958 113.818 56.958 111.515L57.0633 99.0794C57.0844 96.7764 58.9804 94.934 61.2976 94.934L73.5792 95.0178C75.8965 95.0387 77.7503 96.923 77.7503 99.2259L77.645 111.662C77.6239 113.965 75.7279 115.828 73.4107 115.807Z",
                    fill: "#226DFE",
                    fillOpacity: "0.08"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M71.4307 114.154C71.4096 114.154 71.4096 114.154 71.3886 114.154L59.107 114.049C57.8641 114.049 56.7265 113.546 55.8628 112.688C54.9991 111.809 54.5356 110.657 54.5356 109.443L54.641 97.0069C54.662 94.4946 56.7265 92.4637 59.2545 92.4637C59.2755 92.4637 59.2755 92.4637 59.2966 92.4637L71.5782 92.5475C74.1272 92.5684 76.1706 94.6411 76.1495 97.1744L76.0442 109.61C76.0442 110.846 75.5386 111.976 74.6749 112.835C73.7901 113.693 72.6525 114.154 71.4307 114.154ZM59.2334 93.2803C57.1689 93.2803 55.4836 94.9342 55.4626 97.0069L55.3783 109.443C55.3783 110.448 55.7575 111.39 56.4527 112.102C57.1689 112.814 58.0958 113.211 59.107 113.211L71.3886 113.295C72.3997 113.316 73.3477 112.918 74.064 112.227C74.7802 111.516 75.1805 110.594 75.1805 109.59L75.2858 97.1534C75.3069 95.0808 73.6216 93.3849 71.536 93.364L59.2545 93.2803C59.2545 93.2803 59.2545 93.2803 59.2334 93.2803Z",
                    fill: "#226DFE"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M116.828 99.2261H89.1894C88.9577 99.2261 88.7681 99.0377 88.7681 98.8074C88.7681 98.5771 88.9577 98.3887 89.1894 98.3887H116.828C117.06 98.3887 117.25 98.5771 117.25 98.8074C117.25 99.0377 117.06 99.2261 116.828 99.2261Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M134.966 103.958H89.1894C88.9577 103.958 88.7681 103.769 88.7681 103.539C88.7681 103.309 88.9577 103.12 89.1894 103.12H134.966C135.198 103.12 135.387 103.309 135.387 103.539C135.387 103.769 135.198 103.958 134.966 103.958Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M127.698 109.359H89.1894C88.9577 109.359 88.7681 109.171 88.7681 108.94C88.7681 108.71 88.9577 108.522 89.1894 108.522H127.677C127.909 108.522 128.099 108.71 128.099 108.94C128.12 109.171 127.93 109.359 127.698 109.359Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M73.4107 148.384L61.1291 148.301C58.8118 148.28 56.958 146.396 56.958 144.093L57.0633 131.656C57.0844 129.353 58.9804 127.511 61.2976 127.511L73.5792 127.595C75.8965 127.616 77.7503 129.5 77.7503 131.803L77.645 144.239C77.6239 146.563 75.7279 148.405 73.4107 148.384Z",
                    fill: "#226DFE",
                    fillOpacity: "0.08"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M71.4307 146.731C71.4096 146.731 71.4096 146.731 71.3886 146.731L59.107 146.647C57.8641 146.647 56.7265 146.144 55.8628 145.286C54.9991 144.407 54.5356 143.255 54.5356 142.041L54.641 129.605C54.662 127.092 56.7265 125.062 59.2545 125.062C59.2755 125.062 59.2755 125.062 59.2966 125.062L71.5782 125.145C74.1272 125.166 76.1706 127.239 76.1495 129.772L76.0442 142.208C76.0442 143.444 75.5386 144.574 74.6749 145.433C73.7901 146.27 72.6525 146.731 71.4307 146.731ZM59.2334 125.857C57.1689 125.857 55.4836 127.511 55.4626 129.584L55.3783 142.02C55.3783 143.025 55.7575 143.967 56.4527 144.679C57.1689 145.391 58.0958 145.788 59.107 145.788L71.3886 145.872C72.3997 145.893 73.3477 145.495 74.064 144.804C74.7802 144.093 75.1805 143.171 75.1805 142.166L75.2858 129.73C75.3069 127.658 73.6216 125.962 71.536 125.941L59.2545 125.857C59.2545 125.857 59.2545 125.857 59.2334 125.857Z",
                    fill: "#226DFE"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M105.242 131.803H89.1894C88.9577 131.803 88.7681 131.615 88.7681 131.384C88.7681 131.154 88.9577 130.966 89.1894 130.966H105.242C105.474 130.966 105.663 131.154 105.663 131.384C105.663 131.615 105.474 131.803 105.242 131.803Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M134.966 136.535H89.1894C88.9577 136.535 88.7681 136.346 88.7681 136.116C88.7681 135.886 88.9577 135.697 89.1894 135.697H134.966C135.198 135.697 135.387 135.886 135.387 136.116C135.387 136.346 135.198 136.535 134.966 136.535Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M127.698 141.957H89.1894C88.9577 141.957 88.7681 141.769 88.7681 141.538C88.7681 141.308 88.9577 141.12 89.1894 141.12H127.677C127.909 141.12 128.099 141.308 128.099 141.538C128.12 141.769 127.93 141.957 127.698 141.957Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M73.4107 179.558L61.1291 179.474C58.8118 179.453 56.958 177.569 56.958 175.266L57.0633 162.83C57.0844 160.527 58.9804 158.685 61.2976 158.685L73.5792 158.768C75.8965 158.789 77.7503 160.674 77.7503 162.977L77.645 175.413C77.6239 177.716 75.7279 179.579 73.4107 179.558Z",
                    fill: "#226DFE",
                    fillOpacity: "0.08"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M71.4304 177.904C71.4093 177.904 71.4093 177.904 71.3882 177.904L59.1067 177.82C56.5577 177.799 54.5143 175.727 54.5353 173.193L54.6406 160.757C54.6406 159.522 55.1462 158.392 56.0099 157.533C56.8947 156.675 58.0534 156.214 59.2752 156.214L71.5568 156.298C74.1058 156.319 76.1492 158.392 76.1281 160.925L76.0228 173.361C76.0228 174.596 75.5172 175.727 74.6535 176.585C73.7898 177.423 72.6522 177.904 71.4304 177.904ZM71.3882 177.067H71.4093C72.3994 177.067 73.3474 176.69 74.0636 175.978C74.7799 175.266 75.1801 174.345 75.1801 173.34L75.2855 160.904C75.3065 158.831 73.6212 157.135 71.5357 157.114L59.2541 157.031H59.2331C58.243 157.031 57.295 157.408 56.5787 158.119C55.8625 158.831 55.4622 159.752 55.4622 160.757L55.378 173.193C55.3569 175.266 57.0422 176.962 59.1277 176.983L71.3882 177.067Z",
                    fill: "#226DFE"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M125.907 162.977H89.1889C88.9572 162.977 88.7676 162.788 88.7676 162.558C88.7676 162.328 88.9572 162.139 89.1889 162.139H125.886C126.118 162.139 126.307 162.328 126.307 162.558C126.307 162.788 126.139 162.977 125.907 162.977Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M136.482 167.708H89.1889C88.9572 167.708 88.7676 167.52 88.7676 167.289C88.7676 167.059 88.9572 166.871 89.1889 166.871H136.482C136.714 166.871 136.904 167.059 136.904 167.289C136.904 167.52 136.714 167.708 136.482 167.708Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M110.065 173.005H89.1889C88.9572 173.005 88.7676 172.817 88.7676 172.587C88.7676 172.356 88.9572 172.168 89.1889 172.168H110.065C110.297 172.168 110.487 172.356 110.487 172.587C110.487 172.817 110.297 173.005 110.065 173.005Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M134.459 196.835C138.896 192.425 138.896 185.275 134.459 180.866C130.022 176.456 122.828 176.456 118.391 180.866C113.954 185.275 113.954 192.425 118.391 196.835C122.828 201.245 130.022 201.245 134.459 196.835Z",
                    fill: "white"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M127.604 201.309C133.879 201.309 138.966 196.253 138.966 190.017C138.966 183.78 133.879 178.725 127.604 178.725C121.329 178.725 116.242 183.78 116.242 190.017C116.242 196.253 121.329 201.309 127.604 201.309Z",
                    fill: "#ADF0AF"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M126.424 200.533C119.943 200.533 114.662 195.285 114.662 188.844C114.662 182.403 119.943 177.154 126.424 177.154C132.905 177.154 138.186 182.403 138.186 188.844C138.186 195.285 132.925 200.533 126.424 200.533ZM126.424 177.949C120.383 177.949 115.462 182.84 115.462 188.844C115.462 194.848 120.383 199.738 126.424 199.738C132.465 199.738 137.386 194.848 137.386 188.844C137.386 182.84 132.485 177.949 126.424 177.949Z",
                    fill: "#88D58A"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M125.804 192.502C125.704 192.502 125.604 192.462 125.544 192.382L122.103 188.963C121.963 188.824 121.963 188.565 122.103 188.426C122.243 188.287 122.503 188.287 122.643 188.426L125.804 191.567L132.185 185.225C132.325 185.086 132.585 185.086 132.725 185.225C132.865 185.365 132.865 185.623 132.725 185.762L126.064 192.382C126.004 192.462 125.904 192.502 125.804 192.502Z",
                    fill: "white"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M108.675 81.7865H76.0014C75.7697 81.7865 75.5801 81.5981 75.5801 81.3678C75.5801 81.1375 75.7697 80.9491 76.0014 80.9491H108.675C108.907 80.9491 109.096 81.1375 109.096 81.3678C109.096 81.5981 108.907 81.7865 108.675 81.7865Z",
                    fill: "#D1D6E1"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M61.3569 103.687L64.4604 106.387L71.3569 100.387",
                    stroke: "#226DFE",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M61.3569 136.687L64.4604 139.387L71.3569 133.387",
                    stroke: "#226DFE",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M61.3569 167.687L64.4604 170.387L71.3569 164.387",
                    stroke: "#226DFE",
                    strokeLinejoin: "round"
                })
            ]
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M163.732 26.2109L162.742 31.344C161.97 35.3465 163.078 39.4819 165.748 42.5621L169.172 46.5125L164.039 45.5223C160.037 44.7503 155.901 45.8584 152.821 48.5282L148.871 51.9523L149.861 46.8192C150.633 42.8167 149.525 38.6813 146.855 35.601L143.431 31.6507L148.564 32.6408C152.567 33.4129 156.702 32.3048 159.782 29.6349L163.732 26.2109Z",
            fill: "#115CEF"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M5.94057 160.908C5.54052 162.982 6.11468 165.124 7.49811 166.721C5.42416 166.32 3.28134 166.895 1.68527 168.278C2.08532 166.204 1.51115 164.061 0.127722 162.465C2.20168 162.865 4.34449 162.291 5.94057 160.908Z",
            fill: "#115CEF"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M188.973 22.256C188.319 25.6443 189.257 29.145 191.517 31.7526C188.129 31.099 184.628 32.037 182.021 34.2971C182.674 30.9089 181.736 27.4081 179.476 24.8006C182.864 25.4542 186.365 24.5161 188.973 22.256Z",
            fill: "#F5F6F6"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M171.085 4.59372C169.552 4.70313 168.154 5.51026 167.292 6.78324C167.183 5.25017 166.376 3.85217 165.103 2.99088C166.636 2.88147 168.034 2.07434 168.895 0.801364C169.005 2.33444 169.812 3.73243 171.085 4.59372Z",
            fill: "#F5F6F6"
        });
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsxs("svg", {
            width: "192",
            height: "209",
            viewBox: "0 0 192 209",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_19767_266285",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "109.607",
                            height: "140.607",
                            fill: "white",
                            transform: "translate(40 67.7801)"
                        })
                    })
                })
            ]
        });
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
export { AuthGreeting };
